import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { i18n } = useTranslation();

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/3d458f81cabb01f0a16c1b29e0d66493.jpg"
          alt="Doha Skyline"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative h-full max-w-7xl mx-auto px-6 flex items-center">
        <div className="w-full md:w-[60%] lg:w-[55%]">
          <div className="inline-block px-4 py-2 border border-[#D4AF37] rounded-full mb-6">
            <p className="text-xs uppercase tracking-wider text-white">
              {i18n.language === 'ar' ? 'الجسر التجاري الرائد في قطر' : "Qatar's Premier Commercial Bridge"}
            </p>
          </div>

          <h1 className="mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>
            <div className="text-4xl md:text-5xl lg:text-6xl text-white font-light mb-1" style={{ lineHeight: i18n.language === 'ar' ? '1.2' : '1.3' }}>
              {i18n.language === 'ar' ? 'كيمبرلايت:' : 'Kimberlite:'}
            </div>
            <div className="text-3xl md:text-4xl lg:text-5xl font-medium bg-gradient-to-r from-[#D4AF37] to-[#F4D03F] bg-clip-text text-transparent mb-1" style={{ lineHeight: i18n.language === 'ar' ? '1.2' : '1.3' }}>
              {i18n.language === 'ar' ? 'فتح الأبواب أمام الأسواق العالمية' : 'Opening Doors to Global Markets'}
            </div>
            <div className="text-2xl md:text-3xl lg:text-4xl text-white font-light" style={{ lineHeight: i18n.language === 'ar' ? '1.2' : '1.3' }}>
              {i18n.language === 'ar' ? 'من قطر' : 'from Qatar'}
            </div>
          </h1>

          <p className="text-lg md:text-xl text-gray-200 mb-8 leading-relaxed max-w-2xl">
            {i18n.language === 'ar' 
              ? 'خدمات الوساطة التجارية الاستراتيجية من قلب الدوحة، تسهيل التجارة الدولية السلسة عبر القارات.'
              : 'Strategic commercial brokerage services from the heart of Doha, facilitating seamless international trade across continents.'}
          </p>

          <div className="flex flex-wrap gap-4">
            <a
              href="#services"
              className="px-8 py-4 bg-[#1A5F7A] text-white rounded-full font-medium hover:bg-[#D4AF37] transition-all cursor-pointer whitespace-nowrap"
            >
              {i18n.language === 'ar' ? 'استكشف الخدمات' : 'Explore Services'}
            </a>
            <a
              href="#contact"
              className="px-8 py-4 bg-transparent border-2 border-[#D4AF37] text-white rounded-full font-medium hover:bg-[#D4AF37]/20 transition-all cursor-pointer whitespace-nowrap"
            >
              {i18n.language === 'ar' ? 'اتصل بفريقنا' : 'Contact Our Team'}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
